<div
  class="horizontal-nav"
  [ngClass]="{ 'combined-nav': isCombined }"
>
  <base-button
    *ngFor="let tab of tabs; trackBy: trackByTab"
    [size]="tabSize"
    [frontBadge]="tab.data?.badge ?? ''"
    [isImageBadge]="!!tab.data?.isImageBadge"
    [color]="current.id === tab.id ? 'dark' : 'light'"
    [label]="tab.title"
    [disabled]="!!tab?.disabled"
    [ngClass]="{ 'not-allowed': tab.disabled, selected: current.id === tab.id }"
    [stateClass]="tabClass"
    (btnClick)="onTabSelect(tab)"
  >
    <ng-content></ng-content>
  </base-button>
</div>
